// DetectionGalleryPage.tsx
import React from 'react';
import GalleryPageBase from '../../component/GalleryPageBase';

const DetectionGalleryPage: React.FC = () => {
  const galleryConfig = {
    imagesEndpoint: '/api/image-view',
    filterOptionsEndpoint: '/api/filter-options',
    cardClickPath: '/image-view',
    pageType: 'image-view' as const,
    monolithic: true,
  };

  return (
    <GalleryPageBase {...galleryConfig} />
  );
};

export default DetectionGalleryPage;